import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty, get, isEqual } from 'lodash';
import { Form } from 'semantic-ui-react';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import {
  getPreSignInDataAction, dispatchPreSignInData, clearPreSignInData, postSignupAction,
  getSignupAllCurrencyAction, getSignupAllCountryAction, getSignupFilterCurrencyAction,
  getUserListByEmailAction,getSignupAllTimeZoneAction,
  getSelfRegisterEmailAction
} from '../../../actions';
import Input from '../../../components/FormElements/Input';
import routes from '../../../routes';
import './PreSignIn.scss';
import { formFields, confirmationMessage } from "./constant";
import { handleFieldError, handleError } from '../../../utils/form-validation';
import MultiSelect from '../../../components/MultiSelect'
import Select from '../../../components/FormElements/Select';
import SelectNew from '../../../components/FormElements/SelectNew';
import ModalConfirmation from '../../../components/ModalConfirmation'
import { Link } from 'react-router-dom';
import ToastModal from '../../../components/ToastModal'
import illustrationLight from "../../../assets/images/illustrations/auth-register-illustration-light.png";
import bgShape from "../../../assets/images/illustrations/bg-shape-image-light.png";
import logo from '../../../assets/images/bekiLogo.png';
import { isApiCallSuccess } from '../../../selectors';
import { defaultPlatformConfig } from '../../../constants/configuration';

// alert popup
const AlertPopUp = asyncRoute(() => import('../../../components/AlertPopUp'));

const AuthenticationCard = asyncRoute(() => import('../../../components/Card/AuthenticationCard'));
// const TextField = asyncRoute(() => import('../../../components/elements/TextField'));
const Button = asyncRoute(() => import('../../../components/elements/Button'));
const AuthenticationBody = asyncRoute(() => import('../../../components/AuthenticationBody'));



class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      touched: {},
      errors: {},
      tenantid: {},
      submited: false,
      confirmationOpen: false,
      confirmationInfo: '',
      isPreSignInDisabled: true,
      showPreSignInErrorMsg: false,
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: "",
      method: '',
      billingCurrencyOptions: [],
      allTypeOgCurrency: [],
      allCountryOptions: [],
      CurrencyListOptions: [],
      countriesZoneOptions:[],
      timeZoneOptions:[],
      acceptTerms: false,
      logoImage: ''
    };

  }



  async componentWillMount() {
    const { platformConfiguration } = this.props;
    let platformName = platformConfiguration['name'] ? platformConfiguration['name'] : defaultPlatformConfig['name'];
    let logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
    if (platformConfiguration && platformConfiguration['lable']['logo'] && platformConfiguration['lable']['logo'].length > 0) {
      if (platformConfiguration['lable']['logo'][0].hasOwnProperty('path')) {
        logoImageUrl = platformConfiguration['lable']['logo'][0]['path'];
      }
    } else {
      logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
    }
    this.setState({ logoImage: logoImageUrl, platformName });
    let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    await this.allCurrencyFunction();
    await this.allCountryFunction();
    await this.getAllCountryTimeZone()

  }

  getAllCountryTimeZone = async () => {
    const { getSignupAllTimeZoneAction } = this.props
    const type = "COUNTRY_TIMEZONE";
    let { responseCode: { status = '' }, responseList } = await getSignupAllTimeZoneAction();
    if (status.toLowerCase() == "success" && responseList && responseList[0] && responseList[0]['COUNTRY_TIMEZONE']) {
      this.setState({ countriesZoneOptions: responseList[0]['COUNTRY_TIMEZONE'] })
    }
  }


  allCurrencyFunction = async () => {
    const { getSignupAllCurrencyAction } = this.props
    let { responseCode: { status = '' }, responseList } = await getSignupAllCurrencyAction();
    if (status.toLowerCase() == "success") {
      this.setState({ allTypeOgCurrency: responseList[0]['CURRENCY'] })
    }

  }

  allCountryFunction = async () => {
    const { getSignupAllCountryAction } = this.props
    let { responseCode: { status = '' }, responseList } = await getSignupAllCountryAction();
    if (status.toLowerCase() == "success") {
      const optionsCountryList = responseList[0]['Country-Currency'].map((ele, i) => {
        return {
          id: ele.key, value: ele.value
        }
      })
      this.setState({ allCountryOptions: optionsCountryList })
    }

  }






  // componentDidMount() {

  // }




  // componentWillReceiveProps(nextProps) {
  //   const { history } = this.props;
  //   let currentPreSignInStatus = get(this.props, 'preSignInStatus');
  //   let nextPreSignInStatus = get(nextProps, 'preSignInStatus');
  //   if (!isEmpty(nextPreSignInStatus) && !isEqual(currentPreSignInStatus, nextPreSignInStatus)) {
  //     if (isEqual(nextPreSignInStatus, 'Success')) {
  //       history.push(routes.signIn);
  //     } else if (isEqual(nextPreSignInStatus, 'Fail')) {
  //       this.setState({
  //         showPreSignInErrorMsg: true,
  //       });
  //     }
  //   }
  // }

  // handleFormFieldChange(event) {
  //     const formField = { ...this.state.formFieldsState };
  //     const { name, value } = event.target;
  //     formField[name] = value;
  //     this.setState({
  //         formFieldsState: formField,
  //     }, () => {
  //         const isPreSignInDisabled = this.checkPreSignInDisabled();
  //         this.setState({
  //             isPreSignInDisabled,
  //         });
  //     });
  // }

  // checkPreSignInDisabled() {
  //     const {
  //         username,
  //         password
  //     } = this.state.formFieldsState;
  //     return (isEmpty(username)
  //         || isEmpty(password));
  // }

  // handlePreSignSubmit() {
  //     const { formFieldsState } = this.state;
  //     const { dispatchPreSignInData, getPreSignInDataAction } = this.props;
  //     dispatchPreSignInData(formFieldsState).then(() => {
  //         getPreSignInDataAction(formFieldsState);
  //     });
  // }

  // handleRedirectToForgotPassword() {
  //     const { history } = this.props;
  //     console.log(this.props)
  //     history.push(routes.forgotPassword);
  // }
  // handleRedirectSignin() {
  //     const { history } = this.props;
  //     history.push(routes.preSignIn);
  // }

  toggleModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
  };
  confirmationCallBack = (success, info) => {
    const { confirmationOpen } = this.state;
    if (success && info.action.type === 'Confirmation') {
      this.setState({ confirmationOpen: !confirmationOpen }, async () => {
        await this.GenratePayload();
      });
    } else if (info.action.type === 'Success') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push('/' + routes.mainRoute + '/' + routes.preSignIn);
      });
    }


    this.setState({ confirmationOpen: false });
  };

  handleChange = async (e) => {
    const { form, allCountryOptions, countriesZoneOptions } = this.state;
    const { getSignupFilterCurrencyAction } = this.props;
    let { value, name, min, max } = e.target;

    if (min && max) {
      value = Math.max(Number(min), Math.min(Number(max), Number(value)));
    }
    if (name == 'tenantTypeId') {
      const x = formFields.tenantTypeId.options
      const y = x.find((filter) => filter.text == value)
      this.setState({ tenantid: y })
    }


    if (name === 'country') {
      let CurrencyOptions
      if (value) {
        let newCodeForCountry = allCountryOptions.find((cCode) => cCode.value == value)
        let countryID = newCodeForCountry.id
        let { responseCode: { status = '' }, responseList } = await getSignupFilterCurrencyAction({ countryID });
        Object.keys(responseList[0]).map((dataCurrency) => {
          CurrencyOptions = responseList[0][dataCurrency].map((dataCurr) => {
            return {
              id: dataCurr.value, value: dataCurr.value
            }
          })
        })
        if(newCodeForCountry && newCodeForCountry.value){
          const findTimeZoneCountryData = countriesZoneOptions.find((data)=> data.value == newCodeForCountry.value);
          if(findTimeZoneCountryData && findTimeZoneCountryData.attributeChildValues){
            this.setState({timeZoneOptions:findTimeZoneCountryData.attributeChildValues})
          }
        }
        form[formFields.timezone.key] = "";
        this.setState({ CurrencyListOptions: CurrencyOptions})
      }
      form.currency = CurrencyOptions && CurrencyOptions.length && CurrencyOptions.length == 1 ? CurrencyOptions[0].value : '';

    }

    form[name] = value;

    this.setState({ form });
  };

  // handleSelectChange = (event) => {
  //   const { name, value } = event.target;
  //   const { form } = this.state;
  //   form[name] = value;

  //   this.setState({ form }, () => {
  //     if (name === 'billingCountry') {
  //       const selectedCountry = value;
  //       const selectedCountryCurrencies = currenciesData.find(
  //         (country) => country.country === selectedCountry
  //       );


  //       // console.log(selectedCountryCurrencies);

  //       if (selectedCountryCurrencies && selectedCountryCurrencies.currencies && selectedCountryCurrencies.currencies.length > 0) {
  //         let listOptionCurrency = selectedCountryCurrencies.currencies.map((data, index) => { return { id: index, text: data.code } });
  //         form.billingCurrency = listOptionCurrency[0].text;
  //         this.setState({ billingCurrencyOptions: listOptionCurrency, form });
  //       }
  //     }
  //   });
  // };



  handleTouch = (e) => {
    let { touched, form, errors } = this.state;
    let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };

  searchEmailAndAssignId = async (payload) => {
    const { form } = this.state;
    const { getSelfRegisterEmailAction } = this.props;
    let userData = null;
    let userId = null;
    const params = { list: "search", srch: form.email };
    const { responseCode: { status = "" }, responseList = [] } = await getSelfRegisterEmailAction({ tenantId: null, authToken: null, userId, params });
    if (isApiCallSuccess(status)) {
      if (responseList.length > 0) {
        userData = responseList.find((user) => user.email == form.email);
        if (userData) {
          payload['user'][0]['id'] = userData.id;
        }
      }
    }
    return payload;
  };

  GenratePayload = async () => {
    const { form, tenantid, allTypeOgCurrency } = this.state;
    const { postSignupAction, history } = this.props;

    let currencyID = allTypeOgCurrency.find((item) => item.value === form.currency);

    let payload = {
      tenantName: form.accountName.replace(/\s\s+/g, ' '),
      contactPerson: form.username,
      contactEmail: form.email,
      isActive: 1,
      accountType: 0,
      tenantType: tenantid.id,
      currencyType: currencyID.key,
      timezone:+form.timezone,
      tenantMode: 1,

      contact: {
        country: form.country,
        state: "",
        city: "",
        gst: "",
        pincode: "",
        contactPone: "",
        organizationTitle: form.companyName,
        address1: "",
        address2: "",
      },
      // user: [
      //   {
      //     name: form.username,
      //     email: form.email,
      //     uID: form.email,
      //     // contact: form.contact,
      //     isActive: 1,
      //     roleTenantList: [
      //       {
      //         isActive: 1
      //       }
      //     ]
      //   }
      // ],
      miscData: [
        { key: 'connectionManagement', value: 1 },
        { key: 'feeManagement', value: 0 }
      ]
    };

    payload = await this.searchEmailAndAssignId(payload);

    const { responseCode } = await postSignupAction(payload);
    const alertFullyMessage = {
      action: {
        confirmationMessage: responseCode.msg,
        type: "alert",
      },
    };
    const successFullyMessage = {
      action: {
        confirmationMessage: responseCode.msg,
        type: "Success",
      },
    };

    if (responseCode.status.toLowerCase() === "success") {
      // this.setState({ confirmationOpen: false }, () => {
      //   this.toggleModal(successFullyMessage);
      // });
      this.toast(responseCode.status, responseCode.msg)
    } else {
      // this.toggleModal(alertFullyMessage);
      this.toast(responseCode.status, responseCode.msg)
    }

  }




  handleSignUpSubmit = async (e) => {

    // this.GenratePayload();

    e.preventDefault();
    const { form, } = this.state;
    let { errors, valid, } = handleError(form, formFields);
    // let validFlagMulit = this.handleRoleCompetetiorError();
    // let isValidList = true;
    if (valid) {
      this.GenratePayload();
      // this.toggleModal(confirmationMessage);
      // this.setState({ enableToast: true, confirmationMsg: "Are you sure you want to Save this record?", toastMsg: "", toastStatus: "", method: 'Save' });

    } else {
      // let require = { action: { confirmationMessage: 'All Fields Are Required', type: 'error' } };
      // this.toggleModal(require);
      this.setState({ enableToast: true, toastMsg: "All fields are mandatory ", toastStatus: "Fail", method: 'Save' });

      this.setState({ errors: errors, submited: true });
    }

  }



  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  }

  confirmationCallbackModel = (id) => {
    const { method, tableAction, tableRow } = this.state;
    this.setState({ enableToast: false }, () => {
      if (method === "Save") {
        this.GenratePayload();
      }

    });

  }


  handleToastStatus = (status) => {
    const { method } = this.state;

    this.setState({ enableToast: status }, () => {
      if (method === "Save") {
        // this.getSegmentData();
      }


    });
  }

  toggleToast = () => {
    const { enableToast } = this.state;
    this.setState({ enableToast: !enableToast });
  }

  handleAcceptTermsChange = (e) => {
    this.setState({ acceptTerms: e.target.checked });
  };

  // Function to check if all fields are valid and terms are accepted
  isFormValid = () => {

    const { acceptTerms, form } = this.state;
    let { errors, valid, } = handleError(form, formFields);

    // Check if all fields are valid and terms are accepted
    return valid && acceptTerms;
  };


  render() {
    const { formFieldsState, isPreSignInDisabled, showPreSignInErrorMsg, touched, errors, submited, form,
      confirmationOpen, confirmationInfo, enableToast, toastMsg, toastStatus,
      confirmationMsg, method, billingCurrencyOptions, timeZoneOptions, allCountryOptions, CurrencyListOptions, acceptTerms,
      logoImage
    } = this.state;
    const { preSignInMsg, LoginTimer, configurationList } = this.props;

    return (

      <>
        {confirmationOpen && (<ModalConfirmation
          open={confirmationOpen}
          onClose={this.toggleModal}
          confirmationInfo={confirmationInfo}
          handelConfirmationMessage={this.confirmationCallBack}
        />)}



        {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            path={routes.preSignIn}
            idProps={this.props}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
          />
        }
        {/* <AlertPopUp callBackToast={this.toggleToast} showToast={enableToast} heading='Error' iconColor='red' headingColor='red'>
                    <>
                    <p className="errorMsg">{toastMsg}</p>
                    </>
           </AlertPopUp> */}

        <AuthenticationBody>
          <div class="d-none d-lg-flex col-lg-7 p-0">
            <div class="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center">
              <img
                src={illustrationLight}
                alt="auth-register-cover"
                class="img-fluid my-5 auth-illustration"
                data-app-light-img="illustrations/auth-register-illustration-light.png"
                data-app-dark-img="illustrations/auth-register-illustration-dark.png"
              />

              <img
                src={bgShape}
                alt="auth-register-cover"
                class="platform-bg"
                data-app-light-img="illustrations/bg-shape-image-light.png"
                data-app-dark-img="illustrations/bg-shape-image-dark.png"
              />
            </div>
          </div>

          <div class="d-flex col-12 col-lg-5 align-items-center p-sm-5 p-4">
            <div class="w-px-400 mx-auto">
              <form onSubmit={this.handleSignUpSubmit}>
                <a className="logo"><img src={logoImage} width="120px" /></a>
                <p class="mb-4 mt-2">Sign Up to Continue</p>

                <Input
                  onChange={this.handleChange}
                  onBlur={this.handleTouch}
                  value={form[formFields.companyName.key]}
                  setting={formFields[formFields.companyName.key]}
                  error={errors[formFields.companyName.key]}
                  submited={submited}
                  touched={touched[formFields.companyName.key]}
                />

                <Input
                  onChange={this.handleChange}
                  onBlur={this.handleTouch}
                  value={form[formFields.accountName.key]}
                  setting={formFields[formFields.accountName.key]}
                  error={errors[formFields.accountName.key]}
                  submited={submited}
                  touched={touched[formFields.accountName.key]}
                />

                <Input
                  onChange={this.handleChange}
                  onBlur={this.handleTouch}
                  // value={formFieldsState.username}
                  value={form[formFields.username.key]}
                  setting={formFields[formFields.username.key]}
                  error={errors[formFields.username.key]}
                  submited={submited}
                  touched={touched[formFields.username.key]}
                />

                <Input
                  onChange={this.handleChange}
                  onBlur={this.handleTouch}
                  value={form[formFields.email.key]}
                  setting={formFields[formFields.email.key]}
                  error={errors[formFields.email.key]}
                  submited={submited}
                  touched={touched[formFields.email.key]}
                />

                {/* <Select
                  onChange={this.handleChange}
                  onBlur={this.handleTouch}
                  value={form[formFields.country.key]}
                  setting={formFields[formFields.country.key]}
                  error={errors[formFields.country.key]}
                  submited={submited}
                  toggle={() => { alert('toggle'); }}
                  touched={touched[formFields.country.key]}
                  options={allCountryOptions}
                /> */}


                {
                  form[formFields.country.key] ?
                    <div className='custom-test-select new'>
                      <label for="country">Country <span className='text-danger'>*</span></label>
                      <select name="country" onChange={this.handleChange} value={form[formFields.country.key]}>
                        <option value="" disabled >Select</option>
                        {
                          allCountryOptions.map(option => option.value == form[formFields.country.key] ?
                            <option value={option.value} selected>{option.value}</option> : <option value={option.value}>{option.value}</option>

                          )
                        }
                      </select>
                    </div> : <div className='custom-test-select mb-2'>
                      <label for="country">Country <span className='text-danger'>*</span></label>
                      <select name="country" onChange={this.handleChange} value={form[formFields.country.key]} className={errors[formFields.country.key] && errors[formFields.country.key].required ? "has-error" : ""}>
                        <option value="">Select</option>
                        {
                          allCountryOptions != undefined && allCountryOptions.map(option =>
                            <option value={option.value}
                            >{option.value}</option>
                          )
                        }
                      </select>
                      <span className='error-message'>{errors[formFields.country.key] && errors[formFields.country.key].required ? "Country is required" : ""}</span>
                    </div>
                }



                {/* <Select
                  onChange={this.handleChange}
                  onBlur={this.handleTouch}
                  value={form[formFields.currency.key]}
                  setting={formFields[formFields.currency.key]}
                  error={errors[formFields.currency.key]}
                  submited={submited}
                  toggle={() => { alert('toggle'); }}
                  touched={touched[formFields.currency.key]}
                  options={CurrencyListOptions}
                /> */}


                {
                  form[formFields.currency.key] ?
                    <div className='custom-test-select new mt-3'>
                      <label for="currency">Currency <span className='text-danger'>*</span></label>
                      <select name="currency" onChange={this.handleChange} value={form[formFields.currency.key]}>
                        <option value="" disabled >Select</option>
                        {
                          CurrencyListOptions.map(option => option.value == form[formFields.currency.key] ?
                            <option value={option.value} selected>{option.value}</option> : <option value={option.value}>{option.value}</option>

                          )
                        }
                      </select>
                    </div> : <div className='custom-test-select mb-2 mt-3'>
                      <label for="currency">Currency <span className='text-danger'>*</span></label>
                      <select name="currency" onChange={this.handleChange} value={form[formFields.currency.key]} className={errors[formFields.currency.key] && errors[formFields.currency.key].required ? "has-error" : ""}>
                        <option value="">Select</option>
                        {
                          CurrencyListOptions != undefined && CurrencyListOptions.map(option =>
                            <option value={CurrencyListOptions && CurrencyListOptions.length && CurrencyListOptions.length == 1 ? option.value : option.value}
                              selected={CurrencyListOptions && CurrencyListOptions.length && CurrencyListOptions.length == 1 ? option.value : ''}

                            >{option.value}</option>
                          )
                        }
                      </select>
                      <span className='error-message'>{errors[formFields.currency.key] && errors[formFields.currency.key].required ? "Currency is required" : ""}</span>
                    </div>
                }

                <SelectNew
                  onChange={this.handleChange}
                  onBlur={this.handleTouch}
                  value={form[formFields.timezone.key]}
                  setting={formFields[formFields.timezone.key]}
                  error={errors[formFields.timezone.key]}
                  submited={submited}
                  touched={touched[formFields.timezone.key]}
                  options={timeZoneOptions}
                />

                <Select
                  onChange={this.handleChange}
                  onBlur={this.handleTouch}
                  value={form[formFields.tenantTypeId.key]}
                  setting={formFields[formFields.tenantTypeId.key]}
                  error={errors[formFields.tenantTypeId.key]}
                  submited={submited}
                  touched={touched[formFields.tenantTypeId.key]}
                  options={formFields.tenantTypeId.options}
                />
                {/* <Input
                onChange={this.handleChange}
                onBlur={this.handleTouch}
                value={form[formFields.contact.key]}
                // value={formFieldsState.contact}
                setting={formFields[formFields.contact.key]}
                error={errors[formFields.contact.key]}
                submited={submited}
                touched={touched[formFields.contact.key]}
              /> */}


                <div className="form-check mt-n2 ml-2 mb-4">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="acceptTerms"
                    onChange={this.handleAcceptTermsChange}
                    checked={acceptTerms}
                  />
                  <label className="form-check-label pt-1 pl-1" htmlFor="acceptTerms">
                    I accept the <a target="_blank" href="https://beki.torcai.com/privacy-policy.html">terms and conditions</a>
                  </label>
                </div>


                <div className='form-group row justify-content-between mt-3'>
                  <div className='ml-2'>
                    {/* <a href="#" onClick={this.handleRedirectSignin}>
                    Sign In ?
                  </a> */}

                  </div>
                  {/* <div className='mr-2'>
                  <Link to={routes.preSignIn} >Sign In ?</Link>
                </div> */}
                  <p class="text-center">
                    <span>Already have an account? </span>
                    <Link to={routes.preSignIn} >
                      <span>Sign in instead</span>
                    </Link>
                  </p>
                </div>

                <button
                  disabled={!this.isFormValid()} // Call isFormValid to check form validity
                  type='submit'
                  class="btn btn-primary d-grid w-100  heightBtn36 py-2"
                >
                  Sign up
                </button>

                {/* <div className="form-group row">
                <div className="mt-3 ml-3"> */}
                {/* <Button
                  type="submit"
                  disabled={isPreSignInDisabled}
                  content="Sign up" /> */}
                {/* <button type='submit' className='btn btn-primary' >Sign-Up</button>
                  <br />
                </div>
              </div> */}
              </form>
            </div>
          </div>
        </AuthenticationBody >

      </>


    );
  }
}


export default connect(
  state => ({
    platformConfiguration: get(state, 'app.platformConfiguration', '')
  }), {
  postSignupAction,
  getPreSignInDataAction,
  dispatchPreSignInData,
  clearPreSignInData,
  getUserListByEmailAction,
  getSignupAllCurrencyAction,
  getSignupAllTimeZoneAction,
  getSignupAllCountryAction,
  getSignupFilterCurrencyAction,
  getSelfRegisterEmailAction
}
)(Signup);